__turbopack_context__.v({
  "className": "instrument_serif_88a8025a-module__Ptizuq__className",
});
